import { render, staticRenderFns } from "./CilinderChat.vue?vue&type=template&id=fee8c37c&"
import script from "./CilinderChat.vue?vue&type=script&lang=js&"
export * from "./CilinderChat.vue?vue&type=script&lang=js&"
import style0 from "./CilinderChat.vue?vue&type=style&index=0&id=fee8c37c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports